<script >
import BigNumber from 'bignumber.js';
import { nextTick, onMounted, ref } from 'vue-demi';
import { handleMoney, intersectionInit } from '../assets/common';
import useCommon from '../assets/scripts/common';
import request from '../assets/scripts/request';
import { BASE_URL_MAP, MARKET_MAP } from '../conf/index';
import { checkImageLoad, getStockRateInfo } from '../conf/utils';
import StockInfo from '../render/components/stock-info.vue';
import locales from '../render/locales';
const __sfc_main = {};
__sfc_main.props = ['stockInfo', 'appType', 'defaultRateCol', 'regionType', 'cardBgImg'];
__sfc_main.setup = (__props, __ctx) => {
  const {
    useI18n,
    useLang,
    useToast,
    useEnv
  } = require('@fegobull/webapi').use;
  const props = __props;
  const {
    uid,
    jumpLogin
  } = useCommon();
  const $tran = useI18n(locales);
  const {
    langText,
    lang
  } = useLang();
  const Toast = useToast();
  const {
    isPreRender
  } = useEnv();
  const stockComp = ref(null);
  const inited = ref(false);
  const listData = ref([{
    stockId: '',
    iv: '',
    volumeData: '',
    openIntData: '',
    wchStatus: false,
    stockImg: '',
    stockName: '',
    market: '',
    srccode: '',
    price: '',
    curRate: '',
    curRateMinus: ''
  }]);
  const baseUrl = BASE_URL_MAP[props.appType];

  // 获取订阅状态
  const getSubscribeStatus = async stockIds => {
    if (!uid) {
      return;
    }
    const res = await request.getSubscribeStatus({
      stockIds: stockIds.join(',')
    });
    return res;
  };

  // 请求数据
  const requestData = async () => {
    if (!props.stockInfo) {
      return;
    }
    const stockIds = props.stockInfo.map(item => item.stockId);
    const [stockBaseInfo, optionStatisticRes, subscribeStatusRes] = await Promise.all([request.getStockInfo({
      stockIds
    }), request.getOptionStatisticInfo({
      stockIds,
      regionType: props.regionType
    }), getSubscribeStatus(stockIds)]);
    const processedData = await Promise.all(stockBaseInfo.map(async item => {
      const langItem = (item.name || []).find(subItem => subItem.languageId === lang) || {};
      item.stockName = langItem.context || '';
      item.market = MARKET_MAP[`market${item.marketType}`] || '';
      item.srccode = item.codeItem?.srcCode || '';
      item.stockImg = `${baseUrl}/${item.stockId}.jpg`;
      const canLoad = await checkImageLoad(item.stockImg);
      item.stockImg = canLoad ? item.stockImg : '';
      const stockInfo = stockBaseInfo.find(stock => stock.stockId === item.stockId);
      const {
        currentPrice,
        lastClosePrice
      } = stockInfo;
      item.price = Number(currentPrice) ? new BigNumber(currentPrice).multipliedBy(1e3).dividedBy(1e9).dividedBy(1e3).decimalPlaces(2, BigNumber.ROUND_HALF_UP).toFixed(2) : '0';
      const curRateInfo = getStockRateInfo(lastClosePrice, currentPrice);
      item.curRate = curRateInfo.rate;
      item.curRateMinus = curRateInfo.minus;
      const optionStatistic = optionStatisticRes.find(option => option.stockId === item.stockId);
      item.ivTxt = optionStatistic.iv ? `${optionStatistic.iv}%` : '---';
      item.volumeDataTxt = handleMoney(optionStatistic.volumeData || 0).txt || '---';
      item.openIntDataTxt = handleMoney(optionStatistic.openIntData || 0).txt || '---';
      return {
        ...item,
        ...optionStatisticRes.find(option => option.stockId === item.stockId),
        wchStatus: subscribeStatusRes ? subscribeStatusRes[item.stockId] : false
      };
    }));
    listData.value = processedData;
  };

  //订阅
  const subscribeStock = async stockId => {
    if (!uid) {
      return jumpLogin();
    }
    if (!stockId) {
      return;
    }
    try {
      Toast.loading(10);
      await request.subscribeStock({
        stockId
      });
      listData.value.find(item => item.stockId === stockId).wchStatus = true;
      Toast.info($tran('add_success'));
    } catch (err) {
      Toast.error($tran('add_failed'));
    }
  };

  //取消订阅
  const unsubscribeStock = async stockId => {
    if (!uid) {
      return jumpLogin();
    }
    if (!stockId) {
      return;
    }
    try {
      Toast.loading(10);
      await request.unsubscribeStock({
        stockId
      });
      listData.value.find(item => item.stockId === stockId).wchStatus = false;
      Toast.info($tran('remove_success'));
    } catch (err) {
      Toast.error($tran('remove_failed'));
    }
  };
  const initData = async () => {
    try {
      await requestData();
      inited.value = true;
    } catch (err) {
      if (err.isrepeat) {
        return;
      }
      Toast.error($tran('load_failed'));
    }
  };
  onMounted(() => {
    // 预渲染不处理
    if (isPreRender) {
      return;
    }
    nextTick(() => {
      intersectionInit(stockComp.value, initData, inited);
    });
  });
  return {
    $tran,
    langText,
    stockComp,
    listData,
    subscribeStock,
    unsubscribeStock
  };
};
__sfc_main.components = Object.assign({
  StockInfo
}, __sfc_main.components);
export default __sfc_main;
</script>

<template>
    <div class="common-options-trade-card" :class="[langText, 'quotes-color-' + defaultRateCol]" ref="stockComp">
        <div class="options-trade-card">
            <div class="options-trade-item" v-for="item in listData" :key="item.stockId">
                <div class="stock-container">
                    <StockInfo
                        :data="item"
                        @subscribe="subscribeStock(item.stockId)"
                        @unsubscribe="unsubscribeStock(item.stockId)"
                        :app-type="appType"
                    />
                </div>
                <div class="options-box" :style="{ backgroundImage: `url(${cardBgImg})` }">
                    <div class="options-trade-item">
                        <div class="iv-data left">
                            <span class="iv-data-value">{{ item.ivTxt }}</span>
                            <span class="iv-data-text">{{ $tran('iv_data_title') }}</span>
                        </div>
                        <div class="split"></div>
                        <div class="volume-data center">
                            <span class="volume-data-value">{{ item.volumeDataTxt }}</span>
                            <span class="volume-data-text">{{ $tran('volume_data_title') }}</span>
                        </div>
                        <div class="split"></div>
                        <div class="open-int-data right">
                            <span class="open-int-data-value">{{ item.openIntDataTxt }}</span>
                            <span class="open-int-data-text">{{ $tran('open_int_data_title') }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="less" scoped>
@import url(../common.less);
@import url(../stock.less);
</style>
